function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M14.69 89C7.925 78.574 4 66.152 4 52.816 4 31.908 13.651 13.244 28.76 1h84.599A67.324 67.324 0 01123 10.579M128.434 18C134.507 28.192 138 40.132 138 52.897c0 21.52-10.264 40.696-25.742 53.103H29.402A67.74 67.74 0 0120 96.83"
}), /*#__PURE__*/React.createElement("path", {
  vectorEffect: "non-scaling-stroke",
  d: "M82.498 91.5l.002-.2v-9.1c0-5.911-4.703-10.7-10.5-10.7s-10.5 4.789-10.5 10.7v9.1c0 .067 0 .133.002.2h20.996zM40.5 18.5h11v40h-11zM101.5 39.835l-11 7.242V55.5h11V39.835zm-11-6.15l11-7.665V21.5h-11v12.186zM6.706 106.294L142.294 8.707M.706 99.293L136.294 1.707"
}));

function SvgEmergencyElectricityLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 107,
    viewBox: "0 0 143 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyElectricityLarge);
export default __webpack_public_path__ + "static/media/EmergencyElectricityLarge.b9565a5b.svg";
export { ForwardRef as ReactComponent };